export const URL_GET_DATA = '/api/user/all'
export const URL_AUTH = '/api/user/auth'
export const URL_LOGOUT = '/api/user/logout'
export const URL_CHANGE = '/api/user/all/change'
